import { useMutation, useQuery } from "react-query";
import { useAuthStore } from "../store";
import {
  checkHeartBeat,
  getPlatformInfo,
  refetchAccessToken,
  signOut,
} from "../api/idServer";
import { queryClient } from "./client";

export function useSignOut() {
  const { clear } = useAuthStore();
  return useMutation({
    mutationKey: "signOut",
    mutationFn: signOut,
    onSuccess: () => {
      sessionStorage.clear();
      queryClient.invalidateQueries();
      clear();
    },
    onError: () => {},
  });
}

export function useCheckHeartBeat(enabled: boolean) {
  return useQuery({
    queryKey: "heartbeat",
    queryFn: () => checkHeartBeat,
    refetchInterval: 60000, // Refetch every 60 seconds (1 minute)
    refetchOnWindowFocus: "always", // Refetch when the tab regains focus
    staleTime: 0, // Ensure data is treated as stale immediately
    cacheTime: 0, // Avoid caching if unnecessary
    retry: false,
    enabled:
      process.env.NODE_ENV?.includes("local") ||
      process.env.NODE_ENV?.includes("development")
        ? false
        : enabled,
  });
}

export function useRefetchAccessToken(enabled: boolean) {
  return useQuery({
    queryFn: refetchAccessToken,
    queryKey: "refetchAccessToken",
    enabled:
      process.env.NODE_ENV?.includes("local") ||
      process.env.NODE_ENV?.includes("development")
        ? false
        : enabled,
  });
}

export function useGetPlatformInfo(accesstoken: string, enabled?: boolean) {
  return useQuery({
    queryKey: ["getPlatformInfo", accesstoken],
    queryFn: getPlatformInfo,
    enabled:
      process.env.NODE_ENV?.includes("local") ||
      process.env.NODE_ENV?.includes("development")
        ? false
        : enabled,
  });
}
